<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>

    <div class="config-card">
      <div class="config-card__title">下单码物料配置</div>
      <div class="config-card__desc">
        控制商家端App「客户下单码」页面展示哪些进件方式。至少开启一个，否则无法生成下单码。
      </div>
      <el-divider></el-divider>

      <!-- 支付宝下单码 -->
      <div class="config-item">
        <div class="config-item__icon icon-alipay">支</div>
        <div class="config-item__body">
          <div class="config-item__name">支付宝下单码</div>
          <div class="config-item__desc">开启后，商家端展示支付宝进件二维码</div>
        </div>
        <el-switch v-model="config.alipayEnabled" class="switch"></el-switch>
      </div>

      <!-- H5下单码 -->
      <div class="config-item">
        <div class="config-item__icon icon-h5">H</div>
        <div class="config-item__body">
          <div class="config-item__name">H5下单码</div>
          <div class="config-item__desc">开启后，商家端展示H5进件二维码</div>
        </div>
        <el-switch v-model="config.h5Enabled" class="switch"></el-switch>
      </div>

      <!-- 当前组合 -->
      <div class="combo">
        <span class="combo__label">当前组合：</span>
        <span v-if="comboText" class="combo__value">{{ comboText }}</span>
        <span v-else class="combo__empty">未开启任何下单码，商家端无法生成下单码</span>
      </div>

      <div class="config-footer">
        <el-button
          v-checkbtn="isShowBtn(AUTH_BTN.store_material_save)"
          type="primary"
          size="small"
          :loading="saveLoading"
          @click="handleSave"
          >保存配置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';
import { getConfigAPI, saveConfigAPI } from './api';

export default {
  name: 'StoreMaterial',
  mixins: [authBtnMixin],
  data() {
    return {
      config: {
        alipayEnabled: true,
        h5Enabled: true
      },
      saveLoading: false
    };
  },
  computed: {
    // 当前组合描述：都开=双码可切换Tab；单开=对应单码；都关=空
    comboText() {
      const { alipayEnabled, h5Enabled } = this.config;
      if (alipayEnabled && h5Enabled) return '支付宝+H5双码（商家端展示切换Tab）';
      if (alipayEnabled) return '支付宝下单码';
      if (h5Enabled) return 'H5下单码';
      return '';
    }
  },
  mounted() {
    this.getConfig();
  },
  methods: {
    async getConfig() {
      const res = await getConfigAPI();
      this.config = {
        alipayEnabled: !!res?.alipayEnabled,
        h5Enabled: !!res?.h5Enabled
      };
    },
    // 保存配置：至少开启一个，否则报错
    handleSave() {
      const { alipayEnabled, h5Enabled } = this.config;
      if (!alipayEnabled && !h5Enabled) {
        this.$message.error('请至少开启一个下单码');
        return;
      }
      this.saveLoading = true;
      saveConfigAPI({ alipayEnabled, h5Enabled })
        .then(() => {
          this.$message.success('保存成功');
        })
        .finally(() => {
          this.saveLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

.config-card {
  background: #f7f8fa;
  border-radius: 6px;
  padding: 24px 28px;
  width: 100%;

  .config-card__title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }

  .config-card__desc {
    margin-top: 8px;
    font-size: 13px;
    color: #909399;
    line-height: 20px;
  }
}

.config-item {
  display: flex;
  align-items: center;
  padding: 18px 0;
  border-bottom: 1px solid #ebeef5;

  .config-item__icon {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #fff;
    flex-shrink: 0;

    &.icon-alipay {
      background: #1677ff;
    }


    &.icon-h5 {
      background: #52c41a;
    }
  }

.icon-alipay:before {
  content: "";
}

  .config-item__body {
    margin-left: 16px;
    flex: 1;
  }

  .config-item__name {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
  }

  .config-item__desc {
    margin-top: 6px;
    font-size: 13px;
    color: #909399;
  }

  .switch {
    flex-shrink: 0;
    margin-left: 16px;
  }
}

.combo {
  display: flex;
  align-items: center;
  padding: 18px 0;
  font-size: 14px;

  .combo__label {
    color: #606266;
  }

  .combo__value {
    color: #1677ff;
    font-weight: 500;
  }

  .combo__empty {
    color: #f56c6c;
  }
}

.config-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 4px;
}

// 响应式：小屏卡片占满宽度
@media screen and (max-width: 768px) {
  .config-card {
    max-width: 100%;
    padding: 16px;
  }
}
</style>
